import { About } from "../about/About";
import styled from "styled-components";
import Contact from "../../components/Contact";

const BackgroundMainContainer = styled.div`
  display: flex;
  justify-content: center;
  background-color: #0b0c0c;
  flex-direction: column;
`;

const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
`;

const TextTitle = styled.h1`
  font-size: 100px;
  margin: 0;
  color: rgb(255 255 255 / 0.07);
`;

function Home() {
  return (
    <>
      <BackgroundMainContainer>
        <SubContainer>
          <TextTitle>Frontend</TextTitle>
          <TextTitle>Mobile</TextTitle>
          <TextTitle>Developer</TextTitle>
        </SubContainer>
        <About />
        <Contact />
      </BackgroundMainContainer>
    </>
  );
}

export default Home;
